/*! @azure/msal-browser-1p v3.23.0 2024-09-03 */
'use strict';
import { BrowserUtils, BrowserStorage, BrowserCacheLocation } from '@azure/msal-browser';
import { ApplicationInsights } from '@microsoft/1ds-analytics-js';
import { PerformanceEvents } from './TelemetryUtils.mjs';
import { CACHED_REQUEST_PREFIX } from '../cache/TemporaryBrokerStorage.mjs';

/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
// Instrumentation Key for "MATS_Office" Cluster
const instrumentationKey = "faab4ead691e451eb230afc98a28e0f2-698cf73d-7930-426b-87d8-d36936f6912f-7401";
/*
 * Send all MATS data to EU cluster as a temporary solution for EUDB routing.
 * TODO: Find a long term solution for the routing.
 */
const endpointUrlEmma = "https://eu-mobile.events.data.microsoft.com/OneCollector/1.0/";
const profileIdCacheKey = `${CACHED_REQUEST_PREFIX}.mats-telemetry-profile-id`;
class MATSTelemetryReporter {
    constructor(logger, eventsToEmit, appName, appVersion) {
        this.logger = logger;
        this.appName = appName;
        this.appVersion = appVersion;
        this.eventsToEmit = new Set(eventsToEmit);
        this.sessionId = BrowserUtils.createGuid();
        const appInsightsConfigMATS = {
            instrumentationKey,
            endpointUrl: endpointUrlEmma,
            extensions: [],
            propertyConfiguration: {
                gpcDataSharingOptIn: false,
            },
            disableCookiesUsage: true,
        };
        this.appInsightsMATS = new ApplicationInsights();
        this.appInsightsMATS.initialize(appInsightsConfigMATS, []);
        this.logger.verbose("MATSTelemetryReporter: Initialized");
        try {
            const localstorage = new BrowserStorage(BrowserCacheLocation.LocalStorage);
            const cachedProfileId = localstorage.getItem(profileIdCacheKey);
            if (cachedProfileId?.length) {
                this.profileTelemetryId = cachedProfileId;
            }
            else {
                const guid = BrowserUtils.createGuid();
                this.profileTelemetryId = guid;
                localstorage.setItem(profileIdCacheKey, guid);
            }
        }
        catch (e) {
            logger.warning(`MATSTelemetryReporter: local storage is not available`);
            this.profileTelemetryId = "";
        }
    }
    sendCustomEvent(event) {
        if (!this.eventsToEmit.has(event.name)) {
            this.logger.verbose(`MATSTelemetryReporter: Skipping telemetry for ${event.name}`, event.correlationId);
            return;
        }
        const dataToEmit = {
            ...event,
            appName: this.appName,
            appVersion: this.appVersion,
            libraryName: "MSAL-JS",
            profileTelemetryId: this.profileTelemetryId,
            sessionId: this.sessionId,
        };
        // Do not send extended telemetry for troubleshooting to MATS
        delete dataToEmit.context;
        delete dataToEmit.errorStack;
        const eventMATS = {
            name: "actionmsaljs".concat(event.name.toLowerCase() || ""),
            data: dataToEmit,
        };
        this.logger.verbose(`MATSTelemetryReporter: Sending ${eventMATS.name} for tracking`);
        this.appInsightsMATS.track(eventMATS);
        if (event.name === PerformanceEvents.AcquireTokenPreRedirect) {
            this.appInsightsMATS.flush();
        }
    }
}

export { MATSTelemetryReporter };
//# sourceMappingURL=MATSTelemetryReporter.mjs.map
